<ng-container *ngIf="model">
  <div class="time-action-container">
    <div class="time-info-container">
      <span>{{ model.timeText }}</span>
      <span>{{ timeToDisplay }}</span>
    </div>
    <div class="time-action-button">
      <u-button
        type="secondary"
        [fontIcon]="model.actionButton.buttonIcon"
        [styles]="{ height: '16px', width: '16px', border: 'none', padding: '0', background: 'none' }"
        [iconStyles]="{ fontSize: '16px' }"
        tooltipPosition="bottom"
        [pTooltip]="model.actionButton.buttonTooltip"
        tooltipStyleClass="u-tooltip"
        (onClick)="onAction()"
      ></u-button>
    </div>
  </div>
</ng-container>
